import BonusSettingsPanel from './BonusSettingsPanel';

export default BonusSettingsPanel;
